import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import bo from './locales/bo.json';
import zh from './locales/zh.json';
import yue from './locales/yue.json';
import vi from './locales/vi.json';
import ru from './locales/ru.json';
import es from './locales/es.json';
import ne from './locales/ne.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', short: 'EN', native: 'English' },
  { code: 'bo', short: 'BO', native: 'བོད་ཡིག' },
  { code: 'zh', short: 'ZH', native: '简体中文' },
  { code: 'yue', short: 'YU', native: '廣東話' },
  { code: 'vi', short: 'VI', native: 'Tiếng Việt' },
  { code: 'ru', short: 'RU', native: 'Русский' },
  { code: 'es', short: 'ES', native: 'Español' },
  { code: 'ne', short: 'NE', native: 'नेपाली' },
];

const resources = {
  en: { translation: en },
  bo: { translation: bo },
  zh: { translation: zh },
  yue: { translation: yue },
  vi: { translation: vi },
  ru: { translation: ru },
  es: { translation: es },
  ne: { translation: ne },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'bo', 'zh', 'yue', 'vi', 'ru', 'es', 'ne'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'gompa_language',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
